import type { GlobalNav } from '@diligentcorp/atlas-web-component-global-nav/lib/components/GlobalNav.js';

const GLOBAL_NAV_HOST_ID = 'global-navigator';
const ATLAS_GLOBAL_NAV_TAG = 'atlas-global-nav';

function findInShadowTree(root: ParentNode, selector: string): Element | null {
  const direct = root.querySelector(selector);
  if (direct) {
    return direct;
  }

  const elements = root.querySelectorAll('*');
  for (const element of elements) {
    if (element.shadowRoot) {
      const nested = findInShadowTree(element.shadowRoot, selector);
      if (nested) {
        return nested;
      }
    }
  }

  return null;
}

export function queryAtlasGlobalNav(): GlobalNav | null {
  const host = document.getElementById(GLOBAL_NAV_HOST_ID);
  const searchRoot = host?.shadowRoot ?? document;
  const element = findInShadowTree(searchRoot, ATLAS_GLOBAL_NAV_TAG);
  return element ? (element as GlobalNav) : null;
}

/** Collapse or expand the Atlas panel side nav (`display-mode="panel"`). Returns false when nav is not mounted yet. */
export function setAtlasGlobalNavPanelOpen(open: boolean): boolean {
  const nav = queryAtlasGlobalNav();
  if (!nav) {
    return false;
  }

  if (nav._isOpen !== open) {
    nav._isOpen = open;
    nav.requestUpdate();
  }

  return true;
}

export function collapseAtlasGlobalNavPanel(): boolean {
  return setAtlasGlobalNavPanelOpen(false);
}

export function expandAtlasGlobalNavPanel(): boolean {
  return setAtlasGlobalNavPanelOpen(true);
}
